export enum DataLens {
  NATIONAL = 'NATIONAL',
  SUBNATIONAL_PROVINCES = 'SUBNATIONAL_PROVINCES',
  SUBNATIONAL_CITIES = 'SUBNATIONAL_CITIES'
}
  